import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Box,
  IconButton,
  AppBar as MaterialAppBar,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useNetwork } from 'ahooks';
import AppDrawer from 'AppDrawer';
import {
  DRAWER_BREAKPOINT,
  NAV_ITEMS,
  SETTINGS_NAV_ITEM,
  TITLE,
} from 'Constants';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import UserAvatar from 'UserAvatar';

import { isSignInModalOpenAtom, selectUserName } from 'state/signInRecoilState';
import { isDev } from 'utils/utils';

function AppBar() {
  const setIsSignInModalOpen = useSetRecoilState(isSignInModalOpenAtom);
  const userName = useRecoilValue(selectUserName);
  const isOnline = useNetwork().online;
  const signInLabel = isOnline ? userName ?? 'Sign In' : 'Offline';

  const theme = useTheme();
  const isSidebarShown = useMediaQuery(theme.breakpoints.up(DRAWER_BREAKPOINT));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const styles = {
    link: {
      color: theme.palette.primary.main,
      opacity: 0.75,
      textDecoration: 'none',
    },
    activeLink: {
      opacity: 1,
      textDecoration: 'underline',
    },
  };

  return (
    <MaterialAppBar
      color="inherit"
      position="fixed"
    >
      <Toolbar>
        <Box sx={{ display: 'flex' }}>
          <Typography variant="h5">
            <NavLink
              style={() => ({ ...styles.link, whiteSpace: 'nowrap' })}
              to={'/designer' + window.location.search}
            >
              {TITLE}
            </NavLink>
          </Typography>
        </Box>

        {isSidebarShown && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Typography
              variant="h5"
              sx={{ ml: 2, color: theme.palette.primary.main }}
            >
              |
            </Typography>

            {NAV_ITEMS.map(({ label, to }) => (
              <NavLink
                key={to}
                style={(isActive) =>
                  isActive
                    ? { ...styles.link, ...styles.activeLink }
                    : styles.link
                }
                to={to + window.location.search}
              >
                <Typography variant="h6" noWrap>
                  {label}
                </Typography>
              </NavLink>
            ))}
          </Box>
        )}

        <Box sx={{ display: 'flex', ml: 'auto', mr: 0, alignItems: 'center' }}>
          {isSidebarShown ? (
            <>
              <NavLink
                style={(isActive) =>
                  isActive
                    ? { ...styles.link, ...styles.activeLink }
                    : styles.link
                }
                to={SETTINGS_NAV_ITEM.to + window.location.search}
              >
                <IconButton color="inherit" aria-label="Settings">
                  <SettingsIcon />
                </IconButton>
              </NavLink>

              {isDev() && (
                <Box
                  onClick={() => setIsSignInModalOpen(true)}
                  sx={{ display: 'flex', cursor: 'pointer' }}
                >
                  <Box sx={{ mr: 2 }}>
                    <Typography>{signInLabel}</Typography>
                  </Box>
                  <UserAvatar />
                </Box>
              )}
            </>
          ) : (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => setIsDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Box>
      </Toolbar>

      <AppDrawer isOpen={isDrawerOpen} setIsOpen={setIsDrawerOpen}/>
    </MaterialAppBar>
  );
}

export default React.memo(AppBar);
